<script>
import Option from "./Option.svelte";

    export let data;
    export let index;
    export let changeValues;
    let qData = data;

    function removeQuestion(index) {
        console.log('do remove logic here');
    }
    function removeOption(index) {
        console.log('do remove option logic here');
    }

</script>
<div class="edit-question">
    <div class="question-text">
        <div class="number">{index +1 }. </div>
        <input type="text" class="form-control" bind:value={qData.text} on:change={(e) => changeValues(e, index)} />
        <div on:click={removeQuestion} class="remove-button"><i class='bx bx-trash'></i></div>
    </div>
    <div class="question-options">
        {#each data.options as option, i}
            <div style="display:flex;">
                <Option text={option.text} index={i} /> <div on:click={removeOption} class="remove-button"><i class='bx bx-trash'></i></div>
            </div>
        {/each}
    </div>
    
</div>
<style>
    .edit-question {
        margin-bottom:40px;
    }
    .number {
        margin-right:10px;
    }
    .question-text {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .question-options {
        margin-left: 40px;
    }
    .remove-button {
        color: orange;
        margin-left: 10px;
        cursor: pointer;
    }
    .remove-button i {
        padding: 10px;
    }
    .remove-button i:hover {
        background: #f9f9f9;
        border-radius: 50%;
    }
</style>